
import { computed, defineComponent } from 'vue';

export default defineComponent({
    name: 'ProductImage',
    props: {
        sku: { type: String, required: true },
        cacheBust: { type: [String, Number], required: false, default: '1' },
        alt: { type: String, required: false, default: '' },
        lazy: { type: Boolean, default: true, required: false },
        aspectRatio: { type: [Number, Object], default: 16 / 9 },
        widthOnScreen: { type: [Object, Number], default: 100 },
        bgColor: { type: String, default: 'transparent' },
        hidePressModeButton: { type: Boolean, default: false, required: false },
    },
    setup(props) {
        const url = computed(() => {
            return `/products/${props.sku}.webp`;
        });

        return {
            url,
        };
    },
});
